<template>
  <div style="background-color: #233c7c; border-radius: 15px;">
    <b-row style="color: white;">
      <b-col>

        <b-row>
          <b-col class="center-base horizontal">
            <b-img
              :src="user_picture"
              style="width: 100px; height: 100px; object-fit: cover; border-radius: 50%; margin-top: -50px;"
            />
          </b-col>
        </b-row>

        <b-row>
          <b-col class="text-center">
            <span class="sg-sub-heading-text">
              {{ user_name }}
            </span>
          </b-col>
        </b-row>

        <b-row>
          <b-col class="text-center">
            Active User
          </b-col>
        </b-row>

        <b-row class="text-center">
          <b-col>
            <b-button size="sm" v-b-tooltip.hover.bottom title="Message" :variant="getActiveBadge('message')" @click="childClick('message')">
              <font-awesome-icon icon="envelope" /> <b-badge variant="light">0</b-badge>
            </b-button>

            <b-button size="sm" v-b-tooltip.hover.bottom title="Notification" :variant="getActiveBadge('notification')" @click="childClick('notification')">
              <font-awesome-icon icon="bell" /> <b-badge variant="light">0</b-badge>
            </b-button>
          </b-col>
        </b-row>

      </b-col>
    </b-row>

    <b-row class="mt-3">
      <b-col>
        <b-list-group>
          <b-list-group-item class="first" :class="getActiveMenu('basic-info')" @click="childClick('basic-info')">
            <span style="flex-basis: 15%">
              <font-awesome-icon icon="user-alt" />
            </span>
            <span style="flex-basis: 85%">
              Profile
            </span>
          </b-list-group-item>

          <b-list-group-item :class="getActiveMenu('activity')" @click="childClick('activity')">
            <span style="flex-basis: 15%">
              <font-awesome-icon icon="running" />
            </span>
            <span style="flex-basis: 85%">
              Activity
            </span>
          </b-list-group-item>

          <b-list-group-item :class="getActiveMenu('payment')" @click="childClick('payment')">
            <span style="flex-basis: 15%">
              <font-awesome-icon icon="money-bill-wave" />
            </span>
            <span style="flex-basis: 85%">
              Payment
            </span>
          </b-list-group-item>

          <b-list-group-item :class="getActiveMenu('setting')" @click="childClick('setting')">
            <span style="flex-basis: 15%">
              <font-awesome-icon icon="cogs" />
            </span>
            <span style="flex-basis: 85%">
              Setting
            </span>
          </b-list-group-item>

          <!-- <b-list-group-item class="divider" style="cursor: default;" /> -->

          <!-- <b-list-group-item @click="pushRoute('HelpCenter')">
            <span style="flex-basis: 15%">
              <font-awesome-icon icon="headset" />
            </span>
            <span style="flex-basis: 85%">
              Help Center
            </span>
          </b-list-group-item> -->

          <b-list-group-item class="last" @click="logout">
            <span style="flex-basis: 15%">
              <font-awesome-icon icon="sign-out-alt" />
            </span>
            <span style="flex-basis: 85%">
              Sign Out
            </span>
          </b-list-group-item>
        </b-list-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        &nbsp;
      </b-col>
    </b-row>
  </div>
</template>

<script>
// external dependencies
import VueJwtDecode from 'vue-jwt-decode'

// custom component

// api call
import AuthenticationAPI from '@/api/AuthenticationAPI'
import UserFileAPI from '@/api/UserFileAPI'

export default {
  name: 'MyAccount_Sidebar',
  props: ['text'],
  data () {
    return {
      component: 'basic-info',
      user_picture: ''
    }
  },
  beforeCreate: function () {
    if (this.$session.get('jwt') && this.$session.exists()) {
      let decode = VueJwtDecode.decode(this.$session.get('jwt'))
      this.user = decode
      this.user_name = `${decode.first_name} ${decode.last_name}`
    } else {
      this.user = null
      this.user_name = null
    }
  },
  mounted: function () {
    if (this.user) {
      this.getUserPicture()
    }
  },
  methods: {
    // PREREQUISITES
    childClick: function (newComponent) {
      this.$emit('clicked', newComponent)
      this.component = newComponent
    },
    pushRoute: function (newRoute) {
      this.$router.push({ name: newRoute })
    },
    getActiveMenu: function (property) {
      return {
        'current': property === this.component
      }
    },
    getActiveBadge: function (property) {
      return property === this.component ? 'warning' : 'outline-warning'
    },
    // END PREREQUISITES

    // HTTP REQUEST
    logout: async function () {
      try {
        await AuthenticationAPI.logoutTracker(this.user)

        this.$session.destroy()

        this.$cookies.remove(`user_session`)
        this.$cookies.remove(`order_data`)
        this.$cookies.remove(`payment_data`)

        this.$router.push({ name: 'Login' })
      } catch (err) {
        console.log(err)
      }
    },
    getUserPicture: async function () {
      let response = await UserFileAPI.getFile({ _id: this.user.picture })

      if (response.data.record) {
        this.user_picture = this.globalProp.vs + 'u/' + this.user._id + '/user_picture/' + response.data.record.file_name + '.' + response.data.record.file_type
      } else {
        this.user_picture = require('@/assets/img/blank-profile.png')
      }
    }
    // END HTTP REQUEST
  }
}
</script>

<style scoped>
  .list-group-item {
    display: flex;
    cursor: pointer;
    border: 0px;
    background-color: #fafafa;
  }
  .list-group-item.first {
    border-top-left-radius: 15px;
    border-top-right-radius: 15px;
  }
  .list-group-item.last {
    border-bottom-left-radius: 15px;
    border-bottom-right-radius: 15px;
  }

  .list-group-item.current,
  .list-group-item:hover {
    background-color: #c2ccdc;
  }

  .sg-sub-heading-text {
    font-size: 24px;
    color: white;
  }
</style>



// WEBPACK FOOTER //
// src/components/MyAccount/Sidebar/Sidebar.vue